import { getFileTypeIcon } from "../../utils/functions/file-icon-extractor";
import attachmentsPreview from "../../assets/images/attachments-preview.png";
import {
  isImageFile,
  isDocumentFile,
} from "../../pages/Crm/components/HelpDesk/components/KnowledgeBase/FileManagement/utils/fileManagement.utils";
import type { FilePreviewRendererProps } from "../../pages/Crm/components/HelpDesk/components/KnowledgeBase/FileManagement/types/fileManagement.types";
import ImageWithShimmer from "./ImageWithShimmer";

const FilePreviewRenderer = ({
  url,
  fileName,
  fileType,
  className = "",
}: FilePreviewRendererProps) => {
  const fileIconSrc = getFileTypeIcon(`file.${fileType}`);

  if (isImageFile(fileType)) {
    return (
      <ImageWithShimmer
        src={url}
        alt={fileName}
        wrapperClassName={`w-full rounded-lg overflow-hidden ${className}`}
        imgClassName="w-full max-h-[400px] object-contain rounded-lg"
      />
    );
  }

  if (isDocumentFile(fileType)) {
    return (
      <div
        className={`w-full h-[140px] rounded-lg flex items-center justify-center bg-hover-effect dark:bg-hover-effect-dk ${className}`}
      >
        <img src={fileIconSrc} alt={fileName} className="w-9 h-9" />
      </div>
    );
  }

  return (
    <ImageWithShimmer
      src={attachmentsPreview}
      alt={fileName}
      wrapperClassName={`w-full rounded-lg overflow-hidden ${className}`}
      imgClassName="w-full max-h-[400px] object-cover rounded-lg"
    />
  );
};

export default FilePreviewRenderer;
